import { CircularProgress, Box, Modal, Button, Typography } from "@mui/material";
import React from "react";
import { DeleteAssignmentModalController, DeleteAssignmentModalControllerDelegate } from "./controller";

interface State {
  isLoading: boolean;
}

interface Props {
  userUid: string;
  assignmentId: number;
  delegate: DeleteAssignmentModalDelegate;
}

const boxStyle = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: "70%",
  maxWidth: 600,
  bgcolor: 'background.paper',
  borderRadius: 4,
  boxShadow: 24,
  p: 4,
};

export interface DeleteAssignmentModalDelegate {
  shouldCloseModal: () => void;
  applicationShouldLogout: () => void;
  genericError: () => void;
  didDeleteAssignment: () => void;
}

class DeleteAssignmentModal extends React.Component<Props, State> implements DeleteAssignmentModalControllerDelegate {

  controller: DeleteAssignmentModalController

  constructor(props: Props) {
    super(props);
    this.state = {
      isLoading: false
    }
    this.controller = new DeleteAssignmentModalController(this);
  }

  // delegate
  didDeleteAssignment(){
    this.props.delegate.didDeleteAssignment();
  }

  genericError() {
    this.props.delegate.genericError();
  };

  applicationShouldLogout() {
    this.props.delegate.applicationShouldLogout();
  };

  // internals
  didClickDelete() {
    this.setState({isLoading: true});
    const token = localStorage.getItem("AccessToken")!;
    this.controller.deleteAssignment(token, this.props.userUid, this.props.assignmentId)
  }

  didClickClose() {
    this.props.delegate.shouldCloseModal();
  }

  renderLoading() {
    return (
      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        marginTop={2}
      >
        <CircularProgress />
      </Box>
    );
  }

  renderForm() {
    return (
      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        marginTop={2}
      >
        <Typography variant="h3" color="red">
          Confirmar Remoção
        </Typography>
        <Typography variant="body1">
          Tem certeza que deseja remover a Aplicação desse usuário?
        </Typography>
        <Typography variant="body1">
          Isso irá remover todas as respostas do usuário até o momento.
        </Typography>
        <Typography variant="body1">
          Essa ação é irreversível.
        </Typography>
        <Box mt={2} display="flex" flexDirection="row" flexWrap={"wrap"} justifyContent="center" gap={1}>
          <Button
            variant="contained"
            color="error"
            onClick={() => this.didClickDelete()}
          >
            Remover Aplicação
          </Button>
          <Button
            variant="outlined"
            color="error"
            onClick={() => this.didClickClose()}
          >
            Cancelar
          </Button>
        </Box>
      </Box>
    );
  }

  // Internals
  render() {
    return (
      <Modal
        open
        onClose={() => this.didClickClose()}
      >
        <Box
          sx={boxStyle}
        >
          {this.state.isLoading ? this.renderLoading() : this.renderForm()}
        </Box>
      </Modal>
    );
  }
}

export default DeleteAssignmentModal;